import { useTable } from '@composables/common'
import PlatformNameCellRenderer from '@src/partials/platforms/PlatformNameCellRenderer.vue'
import router from '@src/router'
import { Platform, TableSorting } from '@src/types'
import { useUserStore } from '@src/utils/stores/user'
import moment from 'moment'
import { Ref, computed, ref, shallowRef } from 'vue'

export function usePaymentAccountPlatformsTable(platforms: Ref<Platform[]>) {
    const userStore = useUserStore()

    const total = computed(() => {
        return platforms.value.length
    })

    const { TableWrapper: PaymentAccountPlatformsTable } = useTable({
        tableProps: {
            id: 'payment_account_platforms',
            label: 'payment_account_platforms',
            help: 'help_payment_account_platforms_table',
            data: platforms,
            total: total,
            sorting: ref<TableSorting[]>([
                {
                    field: 'created_on',
                    direction: 'desc',
                },
            ]),
            columns: [
                {
                    label: 'id',
                    key: 'platform_uid',
                    select: true,
                },
                {
                    label: 'id',
                    key: 'platform_uid',
                    url: platformsTableUrl,
                    sorting: true,
                    condition: userStore.can('see_id_columns'),
                },
                {
                    label: 'name',
                    key: 'platform_name',
                    cellRenderer: shallowRef(PlatformNameCellRenderer),
                    sorting: true,
                },
                {
                    label: 'created_on',
                    key: 'created_on',
                    sorting: true,
                    cellRenderer: (props: { rowData: Platform }) => {
                        return moment(props.rowData.created_on).format(
                            'DD.MM.yyyy'
                        )
                    },
                },
            ],
            actions: [
                {
                    action: handleViewPlatform,
                    icon: 'fa-eye',
                    title: 'view',
                    condition: userStore.can('view_platforms'),
                },
            ],
        },
    })

    function handleViewPlatform(platform: Platform) {
        router.push({
            name: 'platform',
            params: { slug: platform.platform_name },
        })
    }

    function platformsTableUrl(platform: Platform) {
        return '/platforms/' + platform.platform_name
    }

    return {
        PaymentAccountPlatformsTable,
    }
}
